import Agencies from './Agencies';

export default Agencies;
